<template>
  <div v-bind:class="{ 'op--modal-container':true, hide:!show }" @click="close">
    <div class="op--modal">

      <div class="op--modal-content">
        <div class="shared-box" @click.stop>
          <div class="sb-title">
            {{ $t('rsvpEdit.tryOur') }}
            {{ targetService }}
            {{ $t('rsvpEdit.service') }}</div>
          <div class="sb-body">
            <p>
              <span v-if="allowTime.start !== allowTime.end">
                {{ sharedLabel }}
                {{ $t('rsvpEdit.serviceAvailable') }}
                {{ allowTime.start }}
                {{ $t('rsvpEdit.to') }}
                {{ allowTime.end }}.
              </span>
              <span v-else>
                {{ sharedLabel }}
                {{ $t('rsvpEdit.serviceAirportPickup') }}
              </span>
            </p>
            <p v-show="!!service">
              {{ $t('rsvpEdit.wouldYouLike') }}
              <b>{{ targetService }}</b>
              {{ $t('rsvpEdit.instead') }}
            </p>

            <span class="loaderx"><i class="fa fa-spinner fa-spin" v-show="serviceLoading"></i></span>
            <span class="op-btn btn-success btn-block btn-md margin-t-l"
              @click="selectNextService" v-show="!!service">
              {{ $t('rsvpEdit.yes3') }} {{ targetService }}
            </span>
            <span class="op-btn btn-block btn-md margin-t-s"
              @click="changeDate">
              <span v-show="!!service">No,</span>
              {{ $t('rsvpEdit.changePickupTime') }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ApiQuote from '@/modules/api/edit-quote'

export default {
  name: 'shared-alloted-time-modal',
  // props: ['service', 'code'],
  data () {
    return {
      show: false,
      service: '',
      code: '',
      targetService: ''
    }
  },
  computed: {
    sharedLabel () {
      let services = this.$store.state.rsvpEdit.serviceSelection.services
      if (!services) { return '' }
      if (!services.shared || !services.shared.brandedName) { return 'Shared' }
      return services.shared.brandedName
    },
    allowTime () {
      return {
        start: this.$settings.get('AirportStart'),
        end: this.$settings.get('AirportEnd')
      }
    },
    serviceLoading () { return this.$store.state.rsvpEdit.serviceSelection.isLoading }
  },
  methods: {
    close () {
      this.show = false
      // document.body.className = document.body.className.replace('widget-no-scroll ', '')
      document.body.classList.remove('widget-no-scroll')
    },
    showModal () {
      this.show = true
      // document.body.className = document.body.className.replace('widget-no-scroll ', '')
      // document.body.className += 'widget-no-scroll ' + document.body.className
      document.body.classList.remove('widget-no-scroll')
      document.body.classList.add('widget-no-scroll')
    },
    selectNextService () {
      if (!this.code) { return }
      let service = this.$store.state.rsvpEdit.serviceSelection.services[this.code]
      this.$store.commit('rsvpEdit/setSelectedService', service)
      ApiQuote.updateSelectedService(this)
      this.close()
    },
    changeDate () {
      this.show = false
      document.body.className = document.body.className.replace('widget-no-scroll ', '')
      document.body.classList.remove('widget-no-scroll')
      this.$store.commit('rsvpEdit/showDateTimePicker')
    },
    nextAvailableService () {
      if (this.serviceLoading) { return '' }
      let rsvp = this.$store.state.rsvpEdit.editedRsvp

      let services = ['opoli', 'black', 'suv', 'shuttle']
      let servicesData = this.$store.state.rsvpEdit.serviceSelection.services
      for (let i in services) {
        if (servicesData[services[i]] && rsvp.passengers <= servicesData[services[i]].maxPassengers &&
          rsvp.luggage <= servicesData[services[i]].maxLuggage && servicesData[services[i]].status === 'allowed'
        ) {
          this.code = servicesData[services[i]].code
          this.service = servicesData[services[i]].brandedName
          return
        }
      }

      this.code = ''
      this.service = ''
    }
  },
  watch: {
    show: function (value) {
      this.nextAvailableService()
    },
    service: function (value) {
      if (!value) { this.targetService = 'other' }
      this.targetService = value
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.shared-box{
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}

.sb-title{
  font-size: 21px;
  text-align: center;
  color: #fff;
  background: #5b5b5b;
  padding: 10px;
}

.sb-body{
  padding: 20px;

  p{
    margin-top: 0;
    color: #777;
    margin-bottom: 5px;
  }
}

.loaderx{
  display: block;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// SharedAllotedTimeModal.vue?b8584fb0